/* Litmus spotlight purchase toggle.
   Keeps the hidden selling_plan input and the price inside the add-to-cart
   button in step with the selected purchase option. Without this script the
   form still submits the default option. */
if (!customElements.get('litmus-spotlight-buy')) {
  customElements.define(
    'litmus-spotlight-buy',
    class LitmusSpotlightBuy extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        this.planInput = this.querySelector('[data-selling-plan-input]');
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-purchase-option]')) this.update(event.target);
        });
        const checked = this.querySelector('[data-purchase-option]:checked');
        if (checked) this.update(checked);
      }

      update(option) {
        if (this.planInput) {
          this.planInput.value = option.value;
          this.planInput.disabled = option.value === '';
        }
        this.querySelectorAll('[data-spotlight-price]').forEach((el) => {
          el.textContent = option.dataset.price || '';
        });
      }
    }
  );
}
